import React from 'react';

import { ClImage } from './ClImage';

export interface AvatarProps {
  image?: string | null;
  width?: number;
  height?: number;
}

export const Avatar: React.FC<AvatarProps> = ({
  image,
  width = 16,
  height = 16,
}) => (
  <ClImage
    className="b-imgGallery__img"
    publicId={image || 'avatar.jpg'}
    transformation={{
      height: String(height),
      width: String(width),
      dpr: '2.0',
      crop: 'fill',
      default_image: 'avatar.jpg',
    }}
    height={height}
    width={width}
  />
);
